

<div class="bbb_deals_featured">
  <div class="container">
      <div class="row">
          <div class="col d-flex flex-lg-row flex-column align-items-center justify-content-center">
                   <!-- bbb_deals -->
      <div class="bbb_deals">

        <div class="bbb_deals_slider_container">
          <!-- bbb_deals Item -->
          <div class=" bbb_deals_item">

            <h2 for="example-date-input" style="text-align: center;">{{mensaje.titulo}}. <abbr title="Copia el correo electrónico del usuario y ve al menú lateral izquierdo, elige la sección de arrendador o arrendatario para realizar las acciones respectivas."><i class="fa fa-info-circle" aria-hidden="true"></i></abbr> </h2>


            <div class="bbb_deals_content">

              <div class="available">


                <div class="bbb_deals_item_category">Usuario {{_enviarMensajeService.usuario.rol | lowercase}}:</div>
                <div class="available_title">{{mensaje.correo}}</div>
                <br>
                <div class="bbb_deals_item_category">Asunto del mensaje:</div>
                <div class="available_title">{{mensaje.asunto}}</div>
                <br>
                <div class="bbb_deals_item_category">Fecha recibido:</div>
                <div class="available_title">{{mensaje.fecha | date:'dd-MM-yyyy'}}</div>
                <div class="available_bar"><span style="width:17%"></span></div>
              </div>
            </div>
          </div>
        </div>
      </div> <!-- Featured -->
          </div>
      </div>
  </div>
</div>


